<script setup lang="ts">
    import { InputRow, MultiCombobox } from '@/components/ui/form';

    const props = defineProps<{
        form: any;
        mainForm: any;
        index: number;
        employeeOptions: any;
        userOptions: any;
        isLoadingUserOptions?: boolean;
    }>();
</script>

<template>
    <div class="border-secondary flex flex-col gap-3 rounded-md border p-4">
        <div class="flex items-center justify-between gap-3">
            <span class="text-secondary text-xs">{{ form.name }}</span>
            <span class="text-secondary text-xs font-semibold">{{ form.number }}</span>
        </div>
        <InputRow
            :form="form"
            name="employee_ids"
            label="credit-cards.form.employee_ids"
            :error-key="`vouchers.administrate.${index}.employee_ids`"
        >
            <MultiCombobox
                v-model="form.employee_ids"
                :placeholder="$t('credit-cards.form.employee_ids')"
                :options="employeeOptions"
                label-by="full_name"
                value-by="id"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="user_ids"
            label="credit-cards.form.user_ids"
            :error-key="`vouchers.administrate.${index}.user_ids`"
        >
            <MultiCombobox
                v-model="form.user_ids"
                :placeholder="$t('credit-cards.form.user_ids')"
                :options="userOptions"
                label-by="name"
                value-by="id"
                :loading="isLoadingUserOptions"
            />
        </InputRow>
    </div>
</template>
